import {ValidationSubType} from '../../../../APIs';

export const LivenessValidationSubTypes = {
	...ValidationSubType,
	LivenessOnly: 'LivenessOnly',
} as const;
export type LivenessValidationSubTypes = (typeof LivenessValidationSubTypes)[keyof typeof LivenessValidationSubTypes];
